import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VContainer,{class:{ 'pa-0': !this.$vuetify.breakpoint.mdAndUp }},[_c('spot-list-card',{attrs:{"spots":_vm.spots}})],1),_c(VBtn,{staticClass:"mb-4 mr-4",attrs:{"bottom":"","dark":"","exact":"","fab":"","fixed":"","right":"","to":{ name: 'home' }}},[_c(VIcon,[_vm._v("mdi-map")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }